/*
  قفل تمرير الصفحة — نسخة تشتغل على iOS

  `body { overflow: hidden }` كافية على الديسكتوب وأندرويد، لكن **iOS
  Safari بيتجاهلها** ويفضل يمرّر الصفحة ورا أي نافذة مفتوحة. ودي
  بتطبّق على متصفحات إنستجرام وفيسبوك جوه الآيفون كمان لأنهم WebKit.
  الحل الوحيد اللي بيشتغل هناك هو `position: fixed` على الـ body مع
  تعويض مكان التمرير وإرجاعه بعد القفل.

  المنيو (blur-menu.js) بيعمل ده خلاص لوحده. الملف ده بيوفّر نفس
  الحاجة للكارت دراور والكويك فيو، ومهم إنه **بعدّاد** مش بوليان:
  الكويك فيو بيتفتح من جوه الكارت دراور، فلو الاتنين بيقفلوا ويفكّوا
  من غير عدّ، قفل الكويك فيو كان هيفك الصفحة والدرج لسه مفتوح.

  الاستخدام:
    window.themeScrollLock.lock();
    window.themeScrollLock.unlock();
*/
(function () {
  if (window.themeScrollLock) return;

  var depth = 0;
  var savedY = 0;
  /* حد تاني (المنيو) قافل الصفحة قبلنا — بنعدّ بس ومنلمسش الـ body،
     وإلا هنقرا scrollY = 0 وهو مقفول ونرجّع الصفحة لفوق عند الفك. */
  var external = false;

  function lock() {
    depth += 1;
    if (depth > 1) return;

    var body = document.body;
    if (!body) return;

    if (window.getComputedStyle(body).position === 'fixed') {
      external = true;
      return;
    }

    external = false;
    savedY = window.scrollY || window.pageYOffset || 0;
    body.style.position = 'fixed';
    body.style.top = -savedY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.classList.add('overflow-hidden');
  }

  function unlock() {
    if (depth === 0) return;
    depth -= 1;
    if (depth > 0) return;

    var body = document.body;
    if (!body) return;

    body.classList.remove('overflow-hidden');

    if (external) {
      external = false;
      return;
    }

    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    /* instant مش smooth: ده استرجاع لمكان كان المستخدم فيه أصلاً،
       فأي أنيميشن هنا بتبان كأن الصفحة نطّت. */
    window.scrollTo(0, savedY);
  }

  window.themeScrollLock = {
    lock: lock,
    unlock: unlock,
    depth: function () {
      return depth;
    },
  };
})();
